import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { IControlValidatorFieldValidatorFn } from '../models/control-validator.model';
import { IOfficeField } from '@pages/office/models/office-data.model';
import { FormFieldHelper } from '@pages/office/shared/helpers/form-field.helper';
import { FormFieldControlTypeEnum } from '@pages/office/models/office-form.model';
import { tryParseDecimal } from '@pages/office/shared/utils/try-parse-decimal.util';
import { isEmptyValue } from '@core/helpers/value-empty-checker.helper';

export class NumberMinMaxValidator extends IControlValidatorFieldValidatorFn {
  static override errorKey = 'numberMinMax';

  static errorMessage(columnName: string, param: Partial<{ min: number; max: number }>): string {
    return `${columnName}: ${param.max ? 'Maximum' : 'Minimum'} value for this field is ${param.max ?? param.min}`;
  }

  static validate({ field }: { field: IOfficeField }): ValidatorFn {
    const columnName = field.VistaFormItem.ColumnName;
    const min = Number(field.VistaFormItem.MinValue);
    const max = Number(field.VistaFormItem.MaxValue);
    const isPercent = FormFieldHelper.getControlTypeByWebInputType(field.WebInputType) === FormFieldControlTypeEnum.percent;
    return (control: AbstractControl): ValidationErrors | null => {
      if (isEmptyValue(control.value)) {
        return null;
      }
      const valueToValidate = tryParseDecimal(control.value);
      const isMinValid = valueToValidate >= min;
      const isMaxValid = valueToValidate <= max;

      if ([isMaxValid, isMinValid].every(Boolean)) {
        return null;
      }

      return this.validationErrors(
        this.errorKey,
        this.errorMessage(
          columnName,
          isMinValid ? { max: this.convertMessageValue(isPercent, max) } : { min: this.convertMessageValue(isPercent, min) }
        )
      );
    };
  }

  static convertMessageValue(isPercent: boolean, value: number): number {
    return isPercent ? value * 100 : value;
  }
}
